<template>
  <v-card class="mb-4">
    <v-card-title>
      Verifying Email Addresses
    </v-card-title>
    <v-card-text>
      <div class="d-flex align-center">
        <v-progress-linear height="40"
                           :value="progress"
                           dark>
          <template v-slot:default="{ value }">
            {{ campaign.verified_count | number }} / {{ campaign.subscriber_count | number }}
          </template>
        </v-progress-linear>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    progress: {
      type: Number,
      default: 0,
    }
  },
}
</script>
